const isEmailParam = (pair: string): boolean => {
  const rawKey = pair.split("=")[0];
  try {
    return decodeURIComponent(rawKey) === "email";
  } catch {
    return rawKey === "email";
  }
};

// Removes the `email` param from a query string, leaving every other param untouched.
// Returns "" when nothing is left, otherwise a string starting with "?".
export const removeEmailParam = (search = ""): string => {
  const rawQuery = search.startsWith("?") ? search.slice(1) : search;
  const kept = rawQuery.split("&").filter(pair => pair && !isEmailParam(pair));
  return kept.length ? `?${kept.join("&")}` : "";
};

// Keeps email out of the address bar so it is not sent along with page-level tracking events.
export const stripEmailFromAddressBar = (): void => {
  const { pathname, search, hash } = window.location;
  const cleanSearch = removeEmailParam(search);
  if (cleanSearch === search) return;
  window.history.replaceState(window.history.state, "", `${pathname}${cleanSearch}${hash}`);
};
